import SvgIcon from '@mui/material/SvgIcon'
import React, { useId } from 'react'

import { IconProps } from './types'

const PlotlineRuminationIncreaseIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props
  const clipPathId = useId()

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fill: 'none', fontSize, ...style }} {...rest}>
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M11.389 8.13148L7.38904 4.13148L3.38904 8.13148"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.38904 20.7102L7.38904 4.13146"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.8467 10.7211V14.9771C14.8467 15.0731 14.8947 15.1211 14.9907 15.1211H16.1267C17.396 15.1211 18.3293 14.9184 18.9267 14.5131C19.524 14.0971 19.8227 13.4837 19.8227 12.6731C19.8227 11.1797 18.6973 10.4331 16.4467 10.4331C15.9667 10.4331 15.4813 10.4757 14.9907 10.5611C14.8947 10.5824 14.8467 10.6357 14.8467 10.7211ZM14.6547 21.0411C14.5373 21.1691 14.388 21.2331 14.2067 21.2331C14.0253 21.2331 13.8707 21.1691 13.7427 21.0411C13.6253 20.9131 13.5667 20.7637 13.5667 20.5931V10.5451C13.5667 10.2784 13.652 10.0491 13.8227 9.85705C13.9933 9.65438 14.2067 9.53705 14.4627 9.50505C15.092 9.43038 15.7907 9.39305 16.5587 9.39305C18.052 9.39305 19.1773 9.67038 19.9347 10.2251C20.7027 10.7691 21.0867 11.5477 21.0867 12.5611C21.0867 13.3717 20.868 14.0491 20.4307 14.5931C20.004 15.1264 19.3907 15.4944 18.5907 15.6971C18.58 15.6971 18.5747 15.7077 18.5747 15.7291C18.5747 15.7397 18.58 15.7451 18.5907 15.7451C19.0493 16.0117 19.5187 16.7051 19.9987 17.8251L21.1507 20.6251C21.2147 20.7637 21.1987 20.9024 21.1027 21.0411C21.0173 21.1691 20.8947 21.2331 20.7347 21.2331C20.532 21.2331 20.3453 21.1744 20.1747 21.0571C20.0147 20.9397 19.8973 20.7904 19.8227 20.6091L18.7027 17.8571C18.3827 17.0891 18.0787 16.6144 17.7907 16.4331C17.5133 16.2411 16.9587 16.1451 16.1267 16.1451H14.9907C14.8947 16.1451 14.8467 16.1877 14.8467 16.2731V20.5931C14.8467 20.7637 14.7827 20.9131 14.6547 21.0411Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="24" height="24" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}
export default PlotlineRuminationIncreaseIcon
